import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3 17c-.551 0-1-.448-1-1V6.802c.346.128.72.198 1.107.198H18v2h-2c-1.206 0-3 .799-3 3s1.794 3 3 3h2v2H3zM2.238 3.353A.998.998 0 0 1 3 3h13v2H3.107c-.537 0-1.017-.362-1.093-.824a1 1 0 0 1 .224-.823zM18 13h-1.988C15.55 12.988 15 12.806 15 12s.55-.988 1-1h2v2zm1-8h-1V2a1 1 0 0 0-1-1H3A2.997 2.997 0 0 0 .001 3.956L0 4v12c0 1.654 1.346 3 3 3h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
});

var SvgBalanceMajorMonotone = function SvgBalanceMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgBalanceMajorMonotone as S };